<div class="row display-flex">
    <div class="col-md-4 metrics-table">
        <p class="finzy-txt-p">
            <app-horizontal-loader *ngIf="metrics === undefined"></app-horizontal-loader>
            <span class="text-color-finzy-blue x-big-text" *ngIf="metrics">
                <app-indian-currency-formatter [amount]="metrics.principalOutstanding"></app-indian-currency-formatter>
            </span>
            <br>
            <span class="sub-text">Principal outstanding</span>
        </p>

        <div class="row">
            <hr />
        </div>
        <div *ngIf="networkCallInProgress">
            <p class="finzy-txt-p">
                <app-horizontal-loader *ngIf="metrics === undefined"></app-horizontal-loader>
            </p>
        </div>
        <div *ngIf="!networkCallInProgress && !returnsExists()">
            <p class="finzy-txt-p sub-text finzy-padding-top-10">Next EMI details will be shown as soon as one of
                the loan(s) you have invested gets
                disbursed</p>
        </div>
        <app-horizontal-loader *ngIf="!(upcomingReturns?.expectedEmiDate)"></app-horizontal-loader>
        <div class="row" *ngIf="!networkCallInProgress && returnsExists()">
            <div class="col-xs-6">
                <p class="finzy-txt-p">
                    <span class="medium-text">
                        {{upcomingReturns.expectedEmiDate | dateFormat}}
                    </span>
                    <br>
                    <span class="sub-text">Next EMI Expected</span>
                </p>
            </div>
            <div class="col-xs-6">
                <p class="finzy-txt-p">
                    <span class="medium-text">
                        <app-indian-currency-formatter [amount]="upcomingReturns.expectedEmiAmount">
                        </app-indian-currency-formatter>
                    </span>
                    <br>
                    <span class="sub-text">
                        Expected net EMI
                    </span>
                </p>
            </div>
        </div>
    </div>

    <div class="col-md-4 metrics-table">
        <div>
            <p class="finzy-txt-p finzy-margin-bottom-zero">
                <app-horizontal-loader *ngIf="metrics === undefined"></app-horizontal-loader>
                <span class="text-color-finzy-blue x-big-text" *ngIf="metrics">
                    <app-indian-currency-formatter [amount]="getTotalReturnEarned()"></app-indian-currency-formatter>
                </span>
            </p>
            <p class="sub-text finzy-padding-top-2">Total gross return earned till date <br>(includes prepayment if
                any)</p>
        </div>
        <div class="row">
            <hr />
        </div>
        <div class="row">
            <div class="col-xs-6">
                <p class="finzy-txt-p">
                    <app-horizontal-loader *ngIf="metrics === undefined"></app-horizontal-loader>
                    <span class="medium-text" *ngIf="metrics">
                        <app-indian-currency-formatter [amount]="getReturnedPrincipal()">
                        </app-indian-currency-formatter>
                    </span>
                    <br>
                    <span class="sub-text">Principal returned</span>
                </p>
            </div>
            <div class="col-xs-6">
                <p class="finzy-txt-p">
                    <app-horizontal-loader *ngIf="metrics === undefined"></app-horizontal-loader>
                    <span class="medium-text" *ngIf="metrics">
                        <app-indian-currency-formatter [amount]="getReturnedInterest()"></app-indian-currency-formatter>
                    </span>
                    <br>
                    <span class="sub-text">
                        Interest earned
                    </span>
                </p>
            </div>
        </div>
    </div>
    <div class="col-md-4 metrics-table">
        <div>
            <p style="margin-top:15px;">Return Comparison Across Asset Classes
                <app-tooltip placement="bottom" *ngIf="assetPerformanceTooltipDescriptions.length !== 0">
                    <i class="info-icon material-icons" trigger>info_outline</i>
                    <div content style="width: 88vw; max-width: 503px;">
                        <ul class="document-info-ul-class" *ngFor="let list of assetPerformanceTooltipDescriptions">
                            <li class="document-info-li-class" [innerHTML]="list"></li>
                        </ul>
                    </div>
                </app-tooltip>
            </p>
        </div>
        <app-horizontal-loader *ngIf="assetPerformanceData.length === 0"></app-horizontal-loader>
        <div *ngIf="assetPerformanceData.length !== 0">
            <app-bar-graph [dataSet]="assetPerformanceData"></app-bar-graph>
        </div>
    </div>
</div>
<div class="row display-flex mt-2">
    <div class="col-md-12 metrics-table pt-3 pb-3">
        <div class="row ml-0 mr-0">
            <div class="col-sm-3 col-xs-6 wallet text-left">
                Wallet
            </div>
            <div class="col-sm-3 col-xs-6 amount-in-wallet">
                <div class="row">
                    <p class="metrics-table-heading-font mb-0">
                        <app-indian-currency-formatter [amount]="walletAmount"> </app-indian-currency-formatter>
                    </p>
                    <p class="small-text">
                        Amount in Wallet
                    </p>
                </div>
            </div>
            <div class="col-sm-3 col-xs-6 p-xs-0 text-right metrics-table-heading-font">
                <div *ngIf="loader.spin === true" class="loader wallet-submit-loader">
                    <mat-spinner [diameter]="35"></mat-spinner>
                </div>
                <p *ngIf="loader.spin === false && createPortfolioAllowed" class="add-to-wallet link underline-text"
                    (click)="onClickCreateNewPortfolio()"
                    [class.linkDisabled]="!isCreateNewPortfolioDisabled || isFINXLender"
                    [attr.disabled]="isCreateNewPortfolioDisabled">
                    Create New Portfolio
                </p>
            </div>
            <div class="col-sm-3 col-xs-6 text-right link underline-text add-to-wallet"
                [class.linkDisabled]="isFINXLender" [attr.disabled]="isFINXLender">
                <p (click)="goToWallet()"> Add Fund to Wallet
                </p>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-12 col-xs-12 p-0 m-0">
                <div class="bolt-on-box" *ngIf="isCreateNewPortfolioDisabled === false">
                    <p class="bolt-on-box-message">
                        <i class="fa fa-info-circle"></i> At this moment you won't be able to create a new portfolio as
                        you've opted for finzyBolt. You can change your preference
                        <strong><a [routerLink]="['/preferences']"> here. </a></strong>
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="row display-flex mt-2">
    <div class="col-md-12 metrics-table pt-3 pb-3">
        <div class="row ml-4 mr-0">
            <div class="col-sm-4 col-xs-6 text-left">
                <div class="row">
                    <p class="allocated-loans mb-0">Allocated Loans</p>
                    <p class="small-text">
                        Loans allocated to your investment portfolios
                    </p>
                </div>
            </div>
            <div class="col-sm-4 col-xs-6 text-left">
                <div class="row" style="margin-left: -25px;">
                    <p class="allocated-loans mb-0">{{ allocatedLoans?.length }}</p>
                    <p class="small-text">Number of Allocated loans :</p>
                </div>
            </div>
            <div class="col-sm-4 col-xs-6 text-right link underline-text add-to-wallet">
                <p (click)="getAllocatedLoansRouterLink()"> View Loans</p>
            </div>
        </div>
    </div>
</div>

<section class="row bg-grey display-flex p-4 mt-4" *ngIf="loanSettlementNegotiation?.settledLoansDetails?.length">
    <div class="col-sm-6 col-xs-6">
        <h4 class="font-weight-bold">Settlement requests ({{loanSettlementNegotiation?.settledLoansDetails?.length}})</h4>
    </div>
    <div class="col-sm-6 col-xs-6 text-right">
        <button mat-flat-button class="primary mat-flat-button stroke-btn mat-primary mx-md-5 width-auto"
            (click)="navigateToLoanSettlementPage()">
            Loans Settlement
        </button>
    </div>
</section>

<ng-container *ngIf="!isFINXLender">
    <div class="row display-flex mt-2">
        <p class="metrics-table-heading-alignment metrics-table-heading-font last-line mb-0">
            <strong>Loans are getting filled fast on finzy! See the loans funded by other investors
                <a [class.linkDisabled]="isFINXLender" [attr.disabled]="isFINXLender"
                    [routerLink]="isFINXLender ? [] : ['/recently-filled-loans']">here.</a></strong>
        </p>
    </div>
</ng-container>